import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalKey = 'terminos' | 'privacidad' | 'contacto' | null;
const MODAL_CONTENT: Record<Exclude<ModalKey, null>, {
  title: string;
  body: React.ReactNode;
}> = {
  terminos: {
    title: 'Términos y Condiciones',
    body: <div className="space-y-4 text-sm leading-relaxed text-gray-600" data-id="element-73">
        <p data-id="element-74">
          Al adquirir Código Calma aceptas que el producto es un material
          digital de carácter educativo e informativo. No constituye asesoría
          médica, psicológica ni legal profesional.
        </p>
        <p data-id="element-75">
          El acceso es personal e intransferible. Queda prohibida la
          reproducción, distribución o reventa total o parcial del contenido sin
          autorización expresa.
        </p>
        <p data-id="element-76">
          La compra incluye una garantía de satisfacción de 7 días. Pasado ese
          plazo, no se aceptan devoluciones por tratarse de un producto digital
          de entrega inmediata.
        </p>
      </div>
  },
  privacidad: {
    title: 'Políticas de Privacidad',
    body: <div className="space-y-4 text-sm leading-relaxed text-gray-600" data-id="element-77">
        <p data-id="element-78">
          Tus datos personales (nombre y correo electrónico) se utilizan
          únicamente para procesar tu compra y entregarte el acceso al programa.
        </p>
        <p data-id="element-79">
          No compartimos, vendemos ni cedemos tu información a terceros con
          fines publicitarios. El procesamiento de pagos se realiza a través de
          pasarelas seguras (Mercado Pago).
        </p>
        <p data-id="element-80">
          Puedes solicitar la eliminación de tus datos en cualquier momento
          escribiéndonos a nuestro correo de contacto.
        </p>
      </div>
  },
  contacto: {
    title: 'Contacto',
    body: <div className="space-y-4 text-sm leading-relaxed text-gray-600" data-id="element-81">
        <p data-id="element-82">
          ¿Tienes dudas sobre tu compra, el acceso o quieres solicitar tu
          garantía? Estamos para ayudarte.
        </p>
        <p className="font-semibold text-navy" data-id="element-83">
          Correo: soporte@codigocalma.cl
        </p>
        <p data-id="element-84">Respondemos todas las consultas dentro de 24 a 48 horas hábiles.</p>
      </div>
  }
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalKey>(null);
  const closeModal = () => setActiveModal(null);
  return <footer className="bg-[#0c1526] text-gray-400 py-12 border-t border-white/10" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-86">
        <div className="flex items-center gap-3 mb-8 opacity-80 hover:opacity-100 transition-opacity" data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/h84MHAz1wLnhee739csdrA/_vd-yBYkVV4GGjDCpwrs2rQ_-ulCWs0OSo-cuA9KvxGbUQ_cover.png" alt="Código Calma Logo" className="h-12 object-contain grayscale" data-id="element-88" />
          <span className="text-white font-heading font-bold text-xl tracking-tight" data-id="element-89">
            CÓDIGO CALMA
          </span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-90">
          <button onClick={() => setActiveModal('terminos')} className="hover:text-white transition-colors" data-id="element-91">
            Términos y Condiciones
          </button>
          <button onClick={() => setActiveModal('privacidad')} className="hover:text-white transition-colors" data-id="element-92">
            Políticas de Privacidad
          </button>
          <button onClick={() => setActiveModal('contacto')} className="hover:text-white transition-colors" data-id="element-93">
            Contacto
          </button>
        </div>

        <p className="text-sm text-center" data-id="element-94">
          &copy; {new Date().getFullYear()} Código Calma. Todos los derechos
          reservados.
        </p>
        <p className="text-xs text-center mt-4 max-w-2xl opacity-60" data-id="element-95">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>

      <AnimatePresence data-id="element-96">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60" onClick={closeModal} role="dialog" aria-modal="true" aria-label={MODAL_CONTENT[activeModal].title} data-id="element-97">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 10
        }} transition={{
          duration: 0.2
        }} className="bg-white rounded-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-98">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 sticky top-0 bg-white" data-id="element-99">
                <h3 className="font-heading text-lg font-bold text-navy" data-id="element-100">
                  {MODAL_CONTENT[activeModal].title}
                </h3>
                <button onClick={closeModal} aria-label="Cerrar" className="text-gray-400 hover:text-navy transition-colors p-1 rounded-md hover:bg-gray-100" data-id="element-101">
                  <X size={22} data-id="element-102" />
                </button>
              </div>
              <div className="px-6 py-5" data-id="element-103">{MODAL_CONTENT[activeModal].body}</div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </footer>;
}